export const ONBOARDING_TEST_CONDITIONS = {
	ANDROID: 'android',
	DEFAULT: 'default',
};
